import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const WhatsappScanSuccessModal = ({ isOpen, onDoneClick }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered backdrop>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.CheckCircle size={60} className="text-success" />
          <div className="fs-4 py-2">QR code successfully scanned</div>
          <div className="text-muted text-center px-3">
            It may take up to <strong>60 seconds</strong> for the changes to reflect in the listing.
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onDoneClick} className="px-5 bg-primary border-primary">
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

WhatsappScanSuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  onDoneClick: PropTypes.func
};

export default WhatsappScanSuccessModal;
